export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
</svg>
`;
